import { createActions } from 'redux-actions';

export default createActions({
  AUTH: {
    USER_AUTHENTICATED: undefined
  }
});
